import { skipToken, useQuery } from "@tanstack/react-query";
import { getHunterUserIDLicenseShares } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const HUNTER_LICENSE_SHARES_QUERY_KEY = "HUNTER_LICENSE_SHARES";

export const hunterLicenseSharesKeys = {
  all: [HUNTER_LICENSE_SHARES_QUERY_KEY] as const,
  byUserID: (userID?: number) =>
    [...hunterLicenseSharesKeys.all, userID] as const,
};

export const useHunterLicenseSharesQuery = (userID?: number) =>
  useQuery({
    queryKey: hunterLicenseSharesKeys.byUserID(userID),
    queryFn: userID
      ? processResponseWithApiProblemDetails(() =>
          getHunterUserIDLicenseShares(userID),
        )
      : skipToken,
  });
